<template>
    <div class="tab-body-box">
        <div class="tab-body-header">
            当前库存<font>{{ inventoryData.totalNum }}</font>{{ inventoryData.unit === '无'?'': inventoryData.unit}} / 累计出库{{ inventoryData.outboundNum }}{{ inventoryData.unit === '无'?'': inventoryData.unit}}；累计入库{{ inventoryData.storeNum }}{{ inventoryData.unit === '无'?'': inventoryData.unit}}
        </div>
        <div class="table" style="display: block">
            <Table ref="selection" :row-class-name="rowClassName" :loading="loading" highlight-row :columns="inventoryDataColumns" :data="inventoryData.inventoryList" >
                <template slot-scope="{ row }" slot="是否作废">
                    <font class="grey" v-if="row.status === 1">已作废</font>
                </template>
                <template slot-scope="{ index }" slot="序号">
                    {{ index+1 }}
                </template>
                <template slot-scope="{ row }" slot="填报日期">
                    {{ row.createTime?row.createTime.match(/^\d{4}-\d{2}-\d{2}/)[0]:'' }}
                </template>
                <template slot-scope="{ row }" slot="库存变动">
                    <font v-if="row.operationType === 1" class="green-color">入库</font>
                    <font v-if="row.operationType === 2" class="red-color">出库</font>
                </template>
                <template slot-scope="{ row }" slot="数量">
                    {{ row.num }}{{ row.unit === '无'?'': row.unit}}
                </template>
                <template slot-scope="{ row }" slot="填报人">
                    <span class="create-name"> {{ row.createUser }}</span>
                </template>
                <template slot-scope="{ row }" slot="记录说明">
                    {{ row.describes === '' || row.describes === '无'?'/':row.describes }}
                </template>
                <template slot="操作" slot-scope="{ row }">
                    <a href="javascript:" class="solution-a" @click="onLookRecord(row)">查看详情</a>
                </template>
            </Table>
        </div>
        <!--s: Modal 编辑入库记录-->
        <Modal
            v-model="lookPartsVisible"
            :title="lookPartsArray.operationType === 1?'入库记录':'出库记录'"
            width="500"
            footer-hide>
            <div class="inventory-edit-box">
                <span class="edit-void" v-if="lookPartsArray.operationType!==1 && lookPartsArray.status === 1"></span>
                <ul>
                    <li class="item" style="margin-bottom: 5px">
                        <span class="edit-title">{{ lookPartsArray.sparePartsName }}</span>
                    </li>
                    <li class="item" style="margin-bottom: 5px">
                        <div class="edit-info">
                            <p class="text">设备型号：{{ lookPartsArray.spareModelName || '无' }}</p>
                            <p class="text">生产厂家：{{ lookPartsArray.spareManufacturerName || '无'}}</p>
                            <p class="text">存放地点：{{ lookPartsArray.spareWarehouseName || '无'}}</p>
                        </div>
                    </li>
                    <li class="item" style="margin-bottom: 5px" v-if="JSON.stringify(lookPartsArray) !=='{}'">
                        <span class="label">填报日期：</span>
                        <div class="edit-text">{{ lookPartsArray.createTime.match(/^\d{4}-\d{2}-\d{2}/)[0] }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;填报人：{{ lookPartsArray.createUser }}</div>
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修位置：</span>
                        <Input v-if="lookPartsArray.repairPosition!==''" v-model="lookPartsArray.repairPosition" disabled style="width: 300px" />
                        <div class="edit-text" v-if="lookPartsArray.repairPosition === ''">无</div>
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修部门：</span>
                        <Input v-model="lookPartsArray.deptName" disabled style="width: 300px" />
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修人：</span>
                        <p style="width:300px;line-height: 32px"><font :key="key" v-for="(item,key) in lookPartsArray.userNameList">{{ item }}{{ key+1!== lookPartsArray.userNameList.length?',':''}}</font></p>
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修日期：</span>
                        <Input v-model="lookPartsArray.repairDate" disabled style="width: 300px" />
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 2">
                        <span class="label">更换数量：</span>
                        <Input v-model="lookPartsArray.num" disabled style="width: 80px;margin-right: 10px" />
                        {{ lookPartsArray.unit === '无'?'': lookPartsArray.unit}}
                    </li>
                    <li class="item edit-input" v-if="lookPartsArray.operationType === 2">
                        <span class="label">检修说明：</span>
                        <Input v-model="lookPartsArray.describes" disabled :maxlength="50" show-word-limit type="textarea" style="width: 300px;height:110px" />
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 1">
                        <span class="label">存放地点：</span>
                        <Input v-model="lookPartsArray.spareWarehouseName" disabled style="width: 300px" />
                    </li>
                    <li class="item" v-if="lookPartsArray.operationType === 1">
                        <span class="label">入库数量：</span>
                        <Input v-model="lookPartsArray.num" disabled style="width: 80px;margin-right: 10px" />
                        {{ lookPartsArray.unit === '无'?'': lookPartsArray.unit}}
                    </li>
                    <li class="item edit-input" v-if="lookPartsArray.operationType === 1">
                        <span class="label">入库说明：</span>
                        <Input v-model="lookPartsArray.describes" disabled :maxlength="50" show-word-limit type="textarea" style="width: 300px;height:110px" />
                    </li>
                </ul>
            </div>
        </Modal>
        <!--s: Modal 编辑记录-->
    </div>
</template>

<script>
import Solution from './solution'
export default Solution
</script>
<style lang="less">
@import "solution";
</style>
